import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { materialModules } from '../../../core/constants/mat-modules';
import { PortalDataService } from '../portal-data.service';
import { CountryPhonePipe } from '../../../shared/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'madero-queue',
  templateUrl: './queue.component.html',
  styleUrl: './queue.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [...materialModules, CountryPhonePipe, TranslatePipe],
})
export class QueueComponent {
  readonly portalDataService = inject(PortalDataService);
  readonly #route = inject(ActivatedRoute);
  readonly #snackBar = inject(MatSnackBar);

  leaveQueue = output<void>();

  readonly branch = this.portalDataService.branch;
  readonly entry = this.portalDataService.entry;

  get storeName(): string | null {
    return this.#route.snapshot.queryParamMap.get('store');
  }

  onViewMenu(): void {
    const stores = this.branch()?.stores;

    if (!stores || stores.length === 0) {
      this.#snackBar.open('Cardápio não disponível no momento', 'Fechar', {
        verticalPosition: 'top',
        duration: 5000,
      });
      return;
    }

    const selectedStore = this.getSelectedStore(stores);

    if (selectedStore?.storeMenus && selectedStore.storeMenus.length > 0) {
      const ptMenu =
        selectedStore.storeMenus.find((m: any) => m.languageCode.toLowerCase() === 'pt') ||
        selectedStore.storeMenus[0];
      window.open(ptMenu.url, '_blank');
    }
  }

  private getSelectedStore(stores: any[]) {
    if (!this.storeName || stores.length === 1) {
      return stores[0];
    }

    return stores.find((s) => s.brandName.toLowerCase() === this.storeName!.toLowerCase()) || stores[0];
  }
}
